import {
    app,
    Component,
    payload,
    ojs,
    state,
    v,
    each,
} from "modular-openscriptjs";
import { dom, tool } from "../../../fotastart";
import {
    pageInfo,
    redirect,
    monetary,
    scrollToTop,
    either,
    isMobile,
    cleanDispose,
    consoleLogOnLocal,
    updateStateValue,
    consoleErrorOnLocal,
    inform,
    getCommissionRatesForPrice,
    dataURLtoBlob,
    appendToFormData,
} from "../../../helpers";
import { PAGES, STRINGS, api, dc } from "../../../declarations";
import { $e } from "../../../ojs.events";
import SolidIcon from "../../Blocks/SolidIcon";
import OffcanvasBody from "../../Offcanvas/OffcanvasBody";
import ModalBody from "../../Modals/ModalBody";
import FormField from "../../Blocks/FormField";
import EditProductImageForm from "../../Forms/EditProductImageForm";
import {
    renderCropperToolbar,
    setActiveAspectButton,
    forceFullscreenModalLayout,
    CROP_ASPECT_RATIOS,
} from "../../Forms/CropperToolbar";
import Cropper from "cropperjs";
import Spinner, { SmallSpinner } from "../../Blocks/Spinner";

const h = app("h");
const broker = app("broker");
const router = app("router");

ojs(
    SolidIcon,
    OffcanvasBody,
    ModalBody,
    FormField,
    EditProductImageForm,
    SmallSpinner,
    Spinner,
);

export default class AddProduct extends Component {
    currentStep = state(1);
    sellingPrice = state("");
    packagePrice = state("");

    // Form Sections Toggle
    hasImages = state(false);
    hasAttributes = state(false);
    hasExtras = state(false);
    hasStockInfo = state(false);
    availableAtAllBranches = state(true);
    shouldEnhanceImages = state(false);

    features = state([]); // Array of { name, choice_type, is_required, values: [{value, price}] }
    extras = state([]); // Array of { buyable_id, buyable_type, quantity, name, price }
    selectedBranches = state([]); // Array of branch IDs

    formData = {
        name: "",
        sku: "",
        selling_price: "",
        package_price: "",
        quantity: "",
        processing_time: "",
        available_from: "",
        available_until: "",
        short_description: "",
        branch_id: "",
        company_id: "",
        weight: 1,
        height: 1,
    };

    thumbnail = state(null); // { original, cropped, cropData }
    previewImages = state([]); // Array of { original, cropped, cropData }

    // Feature Form State
    editingFeatureIndex = state(-1);
    currentFeature = state(null);
    featureHolder = null;

    // Product Search for Extras
    extraSearchQuery = state("");
    productSuggestions = state([]);
    loadingProductSuggestions = state(false);
    showProductSuggestions = state(false);
    productSearchTimeout = null;

    // Branches for Step 5
    branches = state([]);
    loadingBranches = state(false);

    // Cropping
    cropper = { obj: null };
    cropperAspectKey = "16-9";
    cropperFlip = { x: 1, y: 1 };

    render() {
        this.formData.company_id = window.currentCompany?.id;
        pageInfo("Add New Product");
        scrollToTop();

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    { class: "row justify-content-center" },
                    h.div(
                        { class: "col-lg-8" },

                        // Progress Header
                        this.renderProgress(),

                        h.div(
                            {
                                class: "card border-0 shadow-sm p-4 p-md-5 overflow-hidden slide-in-from-right",
                                style: "border-radius: 24px; min-height: 500px;",
                            },

                            v(this.currentStep, (step) => {
                                switch (step.value) {
                                    case 1:
                                        return this.renderStep1();
                                    case 2:
                                        return this.renderStep2(); // Images
                                    case 3:
                                        return this.renderStep3(); // Attributes
                                    case 4:
                                        return this.renderStep4(); // Extras
                                    case 5:
                                        return this.renderStep5(); // Availability
                                    default:
                                        return null;
                                }
                            }),
                        ),
                    ),
                ),
            ),
        );
    }

    renderProgress() {
        return h.div(
            { class: "mb-3 text-center" },
            h.div(
                {
                    class: "d-flex justify-content-center align-items-center gap-2 gap-md-3 mb-3",
                },
                [1, 2, 3, 4, 5].map((i) =>
                    v(this.currentStep, (step) =>
                        h.div(
                            {
                                class: `rounded-circle d-flex align-items-center justify-content-center fw-bold transition-all ${
                                    step.value === i
                                        ? "bg-primary text-white shadow"
                                        : step.value > i
                                          ? "bg-success text-white"
                                          : "bg-white text-muted border"
                                }`,
                                style: "width: 40px; height: 40px;",
                            },
                            step.value > i
                                ? h.i({ class: "bi bi-check-lg" })
                                : i,
                        ),
                    ),
                ),
            ),
            v(this.currentStep, (step) =>
                h.h6(
                    { class: "text-muted text-uppercase fw-bold small ls-1" },
                    `Step ${step.value} of 5`,
                ),
            ),
        );
    }

    // --- STEP 1: Basic Information ---
    renderStep1() {
        return h.div(
            { class: "animate-step" },
            h.h3({ class: "fw-bold mb-2" }, "Basic Information"),
            h.p(
                { class: "text-muted mb-5" },
                "Let's start with the core details of your product.",
            ),

            this.renderInput(
                "name",
                "Product Name",
                "e.g. White Chapati",
                "text",
                "The name customers will see first.",
            ),

            h.div(
                { class: "mb-4" },
                h.label(
                    { class: "form-label fw-bold mb-1" },
                    `Base Price (${dc.userCurrency})`,
                ),
                h.input({
                    class: "form-control bg-light border p-3 rounded-3",
                    type: "number",
                    value: this.sellingPrice.value,
                    listeners: {
                        input: (e) => {
                            this.formData.selling_price = e.target.value;
                            this.sellingPrice.value = e.target.value;
                        },
                    },
                    placeholder: "0.00",
                }),
                h.small(
                    { class: "text-muted mt-1 d-block" },
                    "The base price of this item before adjustments.",
                ),
            ),

            h.div(
                { class: "mb-4" },
                h.label(
                    { class: "form-label fw-bold mb-1" },
                    `Packaging Price (${dc.userCurrency})`,
                ),
                h.input({
                    class: "form-control bg-light border p-3 rounded-3",
                    type: "number",
                    value: this.packagePrice.value,
                    listeners: {
                        input: (e) => {
                            this.formData.package_price = e.target.value;
                            this.packagePrice.value = e.target.value;
                        },
                    },
                    placeholder: "0.00",
                }),
                h.small(
                    { class: "text-muted mt-1 d-block" },
                    "e.g. Food container price",
                ),
            ),

            v(this.sellingPrice, (priceState) => {
                const basePrice = parseFloat(priceState.value) || 0;
                if (basePrice <= 0) return null;

                return v(this.packagePrice, (packagePriceState) => {
                const packagePrice = parseFloat(packagePriceState.value) || 0;

                const { customerRate, businessRate } =
                    getCommissionRatesForPrice(basePrice);

                const finalPrice =
                    basePrice + Math.ceil((basePrice * customerRate) / 100) + packagePrice;
                // Packaging is passed straight through to the business - Carata never
                // takes a cut of it - so it's added back on top of the commissioned payout.
                const payout =
                    basePrice - Math.ceil((basePrice * businessRate) / 100) + packagePrice;

                return h.div(
                    {
                        class: "row g-3 mb-4 animate-step flex-nowrap overflow-x-auto pb-2 flex-md-wrap",
                    },
                    // Customer Card: Final Adjusted Price
                    h.div(
                        { class: "col-10 col-md-6 flex-shrink-0" },
                        h.div(
                            {
                                class: "card border-0 shadow-sm p-3 text-center h-100",
                                style: "border-radius: 16px;",
                            },
                            h.i({
                                class: "bi bi-person-fill text-warning fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small fw-semibold" },
                                "Final Adjusted Price",
                            ),
                            h.div(
                                {
                                    class: "small text-muted mb-2",
                                    style: "font-size: 0.75rem;",
                                },
                                "Price customers will see",
                            ),
                            h.div(
                                { class: "fw-bold fs-4 text-dark mb-1" },
                                monetary(finalPrice, dc.userCurrency),
                            ),
                            h.span(
                                {
                                    class: "bg-warning-subtle text-warning-emphasis rounded-pill px-2 py-1 fs-xsm rounded",
                                },
                                `+${customerRate}% Price Markup`,
                            ),
                        ),
                    ),
                    // Business Card: Receive after Carata Commission
                    h.div(
                        { class: "col-10 col-md-6 flex-shrink-0" },
                        h.div(
                            {
                                class: "card border-0 shadow-sm p-3 text-center h-100",
                                style: "border-radius: 16px;",
                            },
                            h.i({
                                class: "bi bi-briefcase-fill text-primary fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small fw-semibold" },
                                "You'll Receive",
                            ),
                            h.div(
                                {
                                    class: "small text-muted mb-2",
                                    style: "font-size: 0.75rem;",
                                },
                                "Amount you'll receive on Purchase",
                            ),
                            h.div(
                                { class: "fw-bold fs-4 text-dark mb-1" },
                                monetary(payout, dc.userCurrency),
                            ),
                            h.span(
                                {
                                    class: "bg-primary-subtle text-primary-emphasis rounded-pill px-2 py-1 fs-xsm rounded",
                                },
                                `-${businessRate}% Carata Commission`,
                            ),
                            packagePrice > 0
                                ? h.div(
                                      {
                                          class: "small text-muted mt-2",
                                          style: "font-size: 0.75rem;",
                                      },
                                      `Includes ${monetary(packagePrice, dc.userCurrency)} packaging fee in full - Carata doesn't commission packaging.`,
                                  )
                                : null,
                        ),
                    ),
                );
                });
            }),

            this.renderSelect(
                "processing_time",
                "Processing Time (Minutes)",
                Array.from({ length: 12 }, (_, i) => {
                    const val = (i + 1) * 5;
                    return { value: val, label: val + " mins" };
                }),
                "Estimated time to prepare this product.",
            ),

            h.div(
                { class: "row g-3 mb-4" },
                h.div(
                    { class: "col-6" },
                    h.label(
                        { class: "form-label fw-bold mb-1" },
                        "Available From",
                    ),
                    h.input({
                        class: "form-control bg-light border p-3 rounded-3",
                        type: "time",
                        value: this.formData.available_from,
                        listeners: {
                            input: (e) =>
                                (this.formData.available_from = e.target.value),
                        },
                    }),
                ),
                h.div(
                    { class: "col-6" },
                    h.label(
                        { class: "form-label fw-bold mb-1" },
                        "Available Until",
                    ),
                    h.input({
                        class: "form-control bg-light border p-3 rounded-3",
                        type: "time",
                        value: this.formData.available_until,
                        listeners: {
                            input: (e) =>
                                (this.formData.available_until = e.target.value),
                        },
                    }),
                ),
                h.small(
                    { class: "text-muted mt-1 d-block" },
                    "Optional - only if this product is only available at certain times of day (e.g. a dinner-only dish).",
                ),
            ),

            this.renderTextarea(
                "short_description",
                "Short Description",
                "Describe the key features and benefits...",
                "Briefly highlight what makes this product special.",
            ),

            h.div(
                {
                    class: "form-check form-switch mb-4 d-flex align-items-center gap-2",
                },
                h.input({
                    class: "form-check-input mt-0",
                    type: "checkbox",
                    role: "switch",
                    id: "stock-toggle",
                    listeners: {
                        change: (e) =>
                            (this.hasStockInfo.value = e.target.checked),
                    },
                }),
                h.label(
                    {
                        class: "form-check-label small fw-bold text-muted text-uppercase",
                        for: "stock-toggle",
                    },
                    "Track Stock & SKU?",
                ),
            ),

            v(this.hasStockInfo, (has) => {
                if (!has.value) return null;

                return h.div(
                    { class: "row g-4 mb-4 animate-step" },
                    h.div(
                        { class: "col-md-6" },
                        this.renderInput(
                            "quantity",
                            "Stock Quantity",
                            "10",
                            "number",
                            "Available units.",
                        ),
                    ),
                    h.div(
                        { class: "col-md-6" },
                        this.renderInput(
                            "sku",
                            "Product SKU",
                            "e.g. WH-1000XM4",
                            "text",
                            "Unique tracking code.",
                        ),
                    ),
                );
            }),

            // The Question
            h.hr({ class: "my-5 opacity-10" }),
            this.renderToggleQuestion(
                "hasImages",
                "Do you have images for this product?",
                "If you don't have, we will generate one for you.",
            ),

            h.div(
                { class: "d-flex justify-content-end mt-5" },
                h.button(
                    {
                        class: "btn btn-primary rounded-pill px-3 fw-bold shadow-sm",
                        listeners: { click: () => this.nextStep() },
                    },
                    "Continue",
                    h.i({ class: "bi bi-arrow-right ms-2" }),
                ),
            ),
        );
    }

    // --- STEP 2: Images ---
    renderStep2() {
        return v(this.hasImages, (has) => {
            if (!has.value) {
                return this.renderSkipStep(
                    "No images needed. Let's move to attributes.",
                    h.hr({ class: "my-5 opacity-10" }),
                    this.renderToggleQuestion(
                        "hasAttributes",
                        "Does this product have variations?",
                        "e.g. Different sizes (Small, Medium, Large) or colors.",
                    ),
                );
            }

            return h.div(
                { class: "animate-step" },
                h.h3({ class: "fw-bold mb-2" }, "Product Visuals"),
                h.p(
                    { class: "text-muted mb-5" },
                    "Showcase your product with high-quality photos.",
                ),

                // Main Thumbnail
                h.div(
                    { class: "mb-5" },
                    h.div(
                        { class: "mb-3" },
                        h.h6({ class: "fw-bold mb-1" }, "Main Product Photo"),
                        h.p(
                            { class: "text-muted small mb-0" },
                            "This is the first image your customers will see.",
                        ),
                    ),
                    v(this.thumbnail, (thumb) =>
                        h.div(
                            {
                                class: "position-relative p-4 border-2 border-dashed rounded-4 text-center cursor-pointer hover-bg-light transition-all",
                                style: "border-color: #dee2e6; min-height: 200px; display: flex; align-items: center; justify-content: center;",
                                listeners: {
                                    click: () =>
                                        this.triggerUpload("thumbnail-input"),
                                },
                            },
                            thumb.value
                                ? [
                                      h.img({
                                          src: thumb.value.cropped,
                                          class: "img-fluid rounded-3",
                                          style: "max-height: 180px;",
                                      }),
                                      h.button(
                                          {
                                              class: "btn btn-danger btn-sm rounded-circle position-absolute",
                                              style: "top: 10px; right: 10px; width: 30px; height: 30px;",
                                              listeners: {
                                                  click: (e) => {
                                                      e.stopPropagation();
                                                      this.thumbnail.value =
                                                          null;
                                                  },
                                              },
                                          },
                                          h.i({ class: "bi bi-x-lg" }),
                                      ),
                                  ]
                                : [
                                      h.div(
                                          {},
                                          h.i({
                                              class: "bi bi-image text-primary display-4 d-block mb-2",
                                          }),
                                          h.span(
                                              { class: "fw-bold d-block" },
                                              "Click to upload main photo",
                                          ),
                                          h.small(
                                              { class: "text-muted" },
                                              "Best size: 1920x1080 pixels",
                                          ),
                                      ),
                                  ],
                        ),
                    ),
                    h.input({
                        type: "file",
                        id: "thumbnail-input",
                        class: "d-none",
                        accept: "image/*",
                        listeners: {
                            change: (e) =>
                                this.handleImageUpload(e, "thumbnail"),
                        },
                    }),
                ),

                // Preview Images Gallery
                h.div(
                    { class: "mb-5" },
                    h.div(
                        { class: "mb-3" },
                        h.h6(
                            { class: "fw-bold mb-1" },
                            "More Photos (Optional)",
                        ),
                        h.p(
                            { class: "text-muted small mb-0" },
                            "Show your product from different angles.",
                        ),
                    ),
                    h.div(
                        { class: "row g-3" },
                        v(
                            this.previewImages,
                            (imgs) => [
                                ...imgs.value.map((img, idx) =>
                                    h.div(
                                        { class: "col-4 col-md-3" },
                                        h.div(
                                            {
                                                class: "position-relative border rounded-3 overflow-hidden bg-light",
                                                style: "padding-top: 100%;",
                                            },
                                            h.img({
                                                src: img.cropped,
                                                class: "position-absolute top-0 start-0 w-100 h-100",
                                                style: "object-fit: cover;",
                                            }),
                                            h.button(
                                                {
                                                    class: "btn btn-danger btn-xs rounded-circle position-absolute",
                                                    style: "top: 5px; right: 5px; padding: 2px 5px;",
                                                    listeners: {
                                                        click: () => {
                                                            updateStateValue(
                                                                this
                                                                    .previewImages,
                                                                (v) => {
                                                                    v.splice(
                                                                        idx,
                                                                        1,
                                                                    );
                                                                    return v;
                                                                },
                                                            );
                                                        },
                                                    },
                                                },
                                                h.i({
                                                    class: "bi bi-x-lg",
                                                    style: "font-size: 10px;",
                                                }),
                                            ),
                                        ),
                                    ),
                                ),
                                h.div(
                                    { class: "col-4 col-md-3" },
                                    h.div(
                                        {
                                            class: "border-2 border-dashed rounded-3 d-flex align-items-center justify-content-center cursor-pointer hover-bg-light transition-all",
                                            style: "padding-top: 100%; position: relative; border-color: #dee2e6;",
                                            listeners: {
                                                click: () =>
                                                    this.triggerUpload(
                                                        "gallery-input",
                                                    ),
                                            },
                                        },
                                        h.div(
                                            {
                                                class: "position-absolute top-50 start-50 translate-middle text-center w-100",
                                            },
                                            h.i({
                                                class: "bi bi-plus-lg text-muted fs-3",
                                            }),
                                            h.small(
                                                {
                                                    class: "d-block text-muted mt-1 px-1",
                                                    style: "font-size: 10px;",
                                                },
                                                "Add Photos",
                                            ),
                                        ),
                                    ),
                                ),
                            ],
                            {
                                class: "d-flex gap-2 flex-wrap",
                            },
                        ),
                    ),
                    h.input({
                        type: "file",
                        id: "gallery-input",
                        class: "d-none",
                        accept: "image/*",
                        multiple: true,
                        listeners: {
                            change: (e) => this.handleImageUpload(e, "gallery"),
                        },
                    }),
                ),

                h.div(
                    {
                        class: "form-check form-switch mb-5 d-flex align-items-center gap-2",
                    },
                    h.input({
                        class: "form-check-input mt-0",
                        type: "checkbox",
                        role: "switch",
                        id: "enhance-images-toggle",
                        listeners: {
                            change: (e) =>
                                (this.shouldEnhanceImages.value =
                                    e.target.checked),
                        },
                    }),
                    h.label(
                        {
                            class: "form-check-label small fw-bold text-muted text-uppercase",
                            for: "enhance-images-toggle",
                        },
                        "Enhance Images? (AI)",
                    ),
                    h.small(
                        { class: "text-muted d-block ms-auto" },
                        "Removes background distractions.",
                    ),
                ),

                h.hr({ class: "my-5 opacity-10" }),

                this.renderToggleQuestion(
                    "hasAttributes",
                    "Does this product have variations?",
                    "e.g. Different sizes (Small, Medium, Large) or colors.",
                ),

                this.renderNavigationButtons(),
            );
        });
    }

    // --- STEP 3: Attributes ---
    renderStep3() {
        return v(this.hasAttributes, (has) => {
            if (!has.value) {
                return this.renderSkipStep(
                    "No variations needed. Let's move to extras.",
                    this.renderToggleQuestion(
                        "hasExtras",
                        "Are there optional extras?",
                        "e.g. Gift wrapping, insurance, or additional accessories.",
                    ),
                );
            }

            return h.div(
                { class: "animate-step" },
                h.div(
                    {
                        class: "d-flex justify-content-between align-items-center mb-4",
                    },
                    h.div(
                        h.h3({ class: "fw-bold mb-1" }, "Product Attributes"),
                        h.p(
                            { class: "text-muted mb-0" },
                            "Add variations like Size, Color, or Material.",
                        ),
                    ),
                ),

                v(this.features, (features) =>
                    h.div(
                        { class: "d-grid gap-4 mb-5" },
                        features.value.length === 0
                            ? h.div(
                                  {
                                      class: "p-5 bg-light rounded-4 text-center text-muted border-dashed",
                                  },
                                  "Click 'Add Attribute' to define variations.",
                              )
                            : features.value.map((f, i) =>
                                  this.renderFeatureItem(f, i),
                              ),
                    ),
                ),

                h.div(
                    { class: "d-flex justify-content-end" },
                    h.button(
                        {
                            class: "align-items-center btn btn-outline-primary d-flex justify-content-center px-3 rounded-pill w-100",
                            listeners: {
                                click: () => this.openFeatureForm(),
                            },
                        },
                        h.i({ class: "bi bi-plus-lg me-2" }),
                        "Add Attribute",
                    ),
                ),

                h.hr({ class: "my-5 opacity-10" }),
                this.renderToggleQuestion(
                    "hasExtras",
                    "Are there optional extras?",
                    "e.g. Gift wrapping, insurance, or additional accessories.",
                ),

                this.renderNavigationButtons(),
            );
        });
    }

    // --- STEP 4: Extras ---
    renderStep4() {
        return v(this.hasExtras, (has) => {
            return h.div(
                { class: "animate-step" },
                h.div(
                    {
                        class: "d-flex justify-content-between align-items-center mb-4",
                    },
                    h.div(
                        h.h3({ class: "fw-bold mb-1" }, "Extras"),
                        h.p(
                            { class: "text-muted mb-0" },
                            "Select other products to offer along with this product.",
                        ),
                    ),
                ),

                v(this.hasExtras, (hasExt) => {
                    if (!hasExt.value)
                        return h.div(
                            {
                                class: "p-5 bg-light rounded-4 text-center text-muted border-dashed",
                            },
                            "You've opted not to include extras.",
                        );

                    return h.div(
                        {},
                        // Product Search for Extras
                        h.div(
                            { class: "mb-4 position-relative" },
                            h.label(
                                {
                                    class: "form-label fw-bold small text-muted",
                                },
                                "SEARCH PRODUCT TO ADD AS EXTRA",
                            ),
                            h.input({
                                class: "form-control bg-light border p-3 rounded-3",
                                placeholder: "Type product name...",
                                id: "extra-product-search-input",
                                listeners: {
                                    input: (e) => this.handleProductSearch(e),
                                    focus: () => {
                                        if (
                                            this.productSuggestions.value
                                                .length > 0
                                        )
                                            this.showProductSuggestions.value = true;
                                    },
                                },
                            }),

                            // Suggestions Dropdown
                            v(this.showProductSuggestions, (show) => {
                                if (!show.value) return null;
                                return h.div(
                                    {
                                        class: "position-absolute w-100 bg-white shadow-lg rounded-4 mt-2 overflow-hidden border",
                                        style: "z-index: 1000; top: 100%; left: 0;",
                                    },
                                    v(
                                        this.loadingProductSuggestions,
                                        (loading) => {
                                            if (loading.value)
                                                return h.div(
                                                    {
                                                        class: "p-4 text-center",
                                                    },
                                                    h.div({
                                                        class: "spinner-border spinner-border-sm text-primary",
                                                    }),
                                                );

                                            return v(
                                                this.productSuggestions,
                                                (sugs) => {
                                                    if (sugs.value.length === 0)
                                                        return h.div(
                                                            {
                                                                class: "p-4 text-muted small text-center",
                                                            },
                                                            "No products found.",
                                                        );

                                                    return h.div(
                                                        {
                                                            class: "list-group list-group-flush",
                                                        },
                                                        ...sugs.value.map(
                                                            (prod) =>
                                                                h.button(
                                                                    {
                                                                        class: "list-group-item list-group-item-action border-0 d-flex align-items-center gap-3 py-3 px-4",
                                                                        onclick:
                                                                            this.method(
                                                                                "addExtraProduct",
                                                                                [
                                                                                    prod,
                                                                                    "${dom.id('extra-product-search-input')}",
                                                                                ],
                                                                            ),
                                                                    },
                                                                    h.img({
                                                                        src:
                                                                            prod.thumbnail_path ||
                                                                            "/assets/images/product-placeholder.png",
                                                                        class: "rounded-3",
                                                                        style: "width: 40px; height: 40px; object-fit: cover;",
                                                                    }),
                                                                    h.div(
                                                                        {},
                                                                        h.div(
                                                                            {
                                                                                class: "fw-bold text-dark",
                                                                            },
                                                                            prod.name,
                                                                        ),
                                                                        h.div(
                                                                            {
                                                                                class: "text-muted small",
                                                                            },
                                                                            `${dc.userCurrency} ${prod.selling_price}`,
                                                                        ),
                                                                    ),
                                                                ),
                                                        ),
                                                    );
                                                },
                                            );
                                        },
                                    ),
                                );
                            }),
                        ),

                        v(this.extras, (extras) =>
                            h.div(
                                { class: "d-grid gap-3 mb-5" },
                                extras.value.length === 0
                                    ? h.div(
                                          {
                                              class: "p-5 bg-light rounded-4 text-center text-muted border-dashed",
                                          },
                                          "Search and add products above.",
                                      )
                                    : extras.value.map((e, i) =>
                                          this.renderExtraItem(e, i),
                                      ),
                            ),
                        ),
                    );
                }),

                h.hr({ class: "my-5 opacity-10" }),
                this.renderToggleQuestion(
                    "availableAtAllBranches",
                    "Available at all your branches?",
                    "By default, this product will be listed in all your shop locations.",
                ),

                this.renderNavigationButtons(),
            );
        });
    }

    // --- STEP 5: Availability ---
    renderStep5() {
        return v(this.availableAtAllBranches, (all) => {
            if (all.value) {
                return h.div(
                    { class: "text-center py-5 animate-step" },
                    h.div(
                        {
                            class: "bg-light rounded-circle circle mx-auto mb-4 p-4",
                            style: "width: 100px; height: 100px;",
                        },
                        h.i({
                            class: "bi bi-fast-forward-fill text-muted fs-1",
                        }),
                    ),
                    h.h4({ class: "fw-bold mb-3" }, "Step Skipped"),
                    h.p(
                        { class: "text-muted mb-5" },
                        "Available at all branches. You're ready to save!",
                    ),
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-center mt-5",
                        },
                        h.button(
                            {
                                class: "btn btn-white border rounded-pill px-3 fw-bold d-flex align-items-center",
                                listeners: { click: () => this.prevStep() },
                            },
                            h.i({ class: "bi bi-arrow-left me-2" }),
                            "Back",
                        ),
                        h.button(
                            {
                                class: "btn btn-success rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center",
                                id: `save-product-btn-${this.id}`,
                                onclick: this.method("submit", "${this}"),
                            },
                            h.span("Finish & Save"),
                            h.i({ class: "bi bi-check-lg ms-2" }),
                        ),
                    ),
                );
            }

            if (
                this.branches.value.length === 0 &&
                !this.loadingBranches.value
            ) {
                this.fetchBranches();
            }

            return h.div(
                { class: "animate-step" },
                h.h3({ class: "fw-bold mb-2" }, "Branch Availability"),
                h.p(
                    { class: "text-muted mb-5" },
                    "Select the specific branches where this product is available.",
                ),

                v(this.loadingBranches, (loading) => {
                    if (loading.value)
                        return h.div(
                            { class: "text-center py-5" },
                            h.Spinner(),
                        );

                    return v(this.branches, (branches) => {
                        if (branches.value.length === 0)
                            return h.div(
                                { class: "text-center py-5 text-muted" },
                                "No branches found.",
                            );

                        return v(this.selectedBranches, (selectedBranches) =>
                            h.div(
                                { class: "row g-3" },
                                ...branches.value.map((branch) => {
                                    const isSelected =
                                        selectedBranches.value.includes(
                                            branch.id,
                                        );
                                    return h.div(
                                        { class: "col-12" },
                                        h.div(
                                            {
                                                class: `card border-2 cursor-pointer transition-all ${
                                                    isSelected
                                                        ? "border-primary bg-primary-subtle bg-opacity-10"
                                                        : "border-light bg-light"
                                                }`,
                                                style: "border-radius: 16px;",
                                                listeners: {
                                                    click: () =>
                                                        this.toggleBranch(
                                                            branch.id,
                                                        ),
                                                },
                                            },
                                            h.div(
                                                {
                                                    class: "card-body d-flex align-items-center gap-3 p-3",
                                                },
                                                h.div(
                                                    {
                                                        class: `rounded-circle d-flex align-items-center justify-content-center ${
                                                            isSelected
                                                                ? "bg-primary text-white"
                                                                : "bg-white text-muted border"
                                                        }`,
                                                        style: "width: 24px; height: 24px;",
                                                    },
                                                    isSelected
                                                        ? h.i({
                                                              class: "bi bi-check-lg",
                                                          })
                                                        : null,
                                                ),
                                                h.div(
                                                    {},
                                                    h.div(
                                                        { class: "fw-bold" },
                                                        branch.name,
                                                    ),
                                                    h.div(
                                                        {
                                                            class: "small text-muted",
                                                        },
                                                        branch.readable_address,
                                                    ),
                                                ),
                                            ),
                                        ),
                                    );
                                }),
                            ),
                        );
                    });
                }),

                h.div(
                    {
                        class: "d-flex justify-content-between align-items-center mt-5",
                    },
                    h.button(
                        {
                            class: "btn btn-white border rounded-pill px-3 fw-bold d-flex align-items-center",
                            listeners: { click: () => this.prevStep() },
                        },
                        h.i({ class: "bi bi-arrow-left me-2" }),
                        "Back",
                    ),
                    h.button(
                        {
                            class: "btn btn-success rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center",
                            id: `save-product-btn-${this.id}`,
                            onclick: this.method("submit", "${this}"),
                        },
                        "Finish & Save",
                        h.i({ class: "bi bi-check-lg ms-2" }),
                    ),
                ),
            );
        });
    }

    // --- Attribute Form (Feature) ---
    openFeatureForm(index = -1) {
        if (this.featureHolder) {
            cleanDispose(this.featureHolder);
        }

        let feature = this.features.value[index] ?? null;

        this.editingFeatureIndex.value = index;
        this.currentFeature.value = feature
            ? tool.deepCopy(feature)
            : {
                  name: "",
                  choice_type: "single_choice",
                  is_required: true,
                  has_different_prices: false,
                  values: [{ value: "", price: "" }],
                  price_interval: "",
                  price_per_interval: "",
              };

        const form = () => this.renderFeatureForm();

        if (isMobile()) {
            this.featureHolder = tool.offcanvas(h.OffcanvasBody(form()), {
                class: "rounded-top-5",
            });
        } else {
            this.featureHolder = tool.plainModal(h.ModalBody(form()));
        }

        this.featureHolder.show();
    }

    renderFeatureForm() {
        return h.div(
            { class: "p-2" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4(
                    { class: "fw-bold mb-0" },
                    v(this.editingFeatureIndex, (i) =>
                        i.value === -1 ? "New Attribute" : "Edit Attribute",
                    ),
                ),
                h.button({
                    class: "btn-close",
                    listeners: { click: () => this.featureHolder.hide() },
                }),
            ),

            v(this.currentFeature, (feat) => {
                if (!feat.value) return null;

                return h.div(
                    h.div(
                        { class: "mb-4" },
                        h.label(
                            { class: "form-label fw-bold small text-muted" },
                            "ATTRIBUTE NAME",
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            placeholder: "e.g. Color or Size",
                            value: feat.value.name,
                            listeners: {
                                input: (e) => {
                                    feat.value.name = e.target.value;
                                },
                            },
                        }),
                        h.small(
                            { class: "text-muted d-block mt-1" },
                            "Example: Shirt Size, Laptop RAM, etc.",
                        ),
                    ),

                    // Choice Type
                    h.div(
                        { class: "mb-4" },
                        h.label(
                            { class: "form-label fw-bold small text-muted" },
                            "INPUT TYPE",
                        ),
                        h.select(
                            {
                                class: "form-select bg-light border p-3 rounded-3",
                                listeners: {
                                    change: (e) => {
                                        updateStateValue(feat, (value) => {
                                            value.choice_type = e.target.value;
                                            return value;
                                        });
                                    },
                                },
                            },
                            h.option(
                                {
                                    value: "single_choice",
                                },
                                either(
                                    feat.value.choice_type === "single_choice",
                                    {
                                        selected: true,
                                    },
                                ),
                                "Single Choice (Dropdown)",
                            ),
                            h.option(
                                {
                                    value: "multiple_choice",
                                },
                                either(
                                    feat.value.choice_type ===
                                        "multiple_choice",
                                    {
                                        selected: true,
                                    },
                                ),
                                "Multiple Choice (Checkboxes)",
                            ),
                            h.option(
                                { value: "text" },
                                either(feat.value.choice_type === "text", {
                                    selected: true,
                                }),
                                "Text Input (Custom message)",
                            ),
                            h.option(
                                { value: "number" },
                                either(feat.value.choice_type === "number", {
                                    selected: true,
                                }),
                                "Number Input",
                            ),
                        ),
                    ),

                    // Required Toggle
                    h.div(
                        { class: "mb-4 py-2 border-bottom border-top" },
                        this.renderToggleQuestionInForm(
                            "is_required",
                            "Required for Order?",
                            "Should customers be forced to choose this before buying?",
                        ),
                    ),

                    // Options (Only if Choice Type)
                    either(
                        ["single_choice", "multiple_choice"].includes(
                            feat.value.choice_type,
                        ),
                        () => [
                            h.div(
                                {
                                    class: "d-flex justify-content-between align-items-center mb-3",
                                },
                                h.h6({ class: "fw-bold mb-0" }, "Options"),

                                either(
                                    feat.value.choice_type === "single_choice",
                                    () =>
                                        h.div(
                                            { class: "form-check form-switch" },
                                            h.input(
                                                {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    role: "switch",
                                                    id: "price-toggle",
                                                    listeners: {
                                                        change: (e) => {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.has_different_prices =
                                                                e.target.checked;
                                                            feat.value =
                                                                current;
                                                        },
                                                    },
                                                },
                                                either(
                                                    feat.value
                                                        .has_different_prices,
                                                    {
                                                        checked: true,
                                                    },
                                                ),
                                            ),
                                            h.label(
                                                {
                                                    class: "form-check-label small text-muted",
                                                    for: "price-toggle",
                                                },
                                                "Custom Prices",
                                            ),
                                        ),
                                ),
                            ),
                            h.div(
                                { class: "d-grid gap-2 mb-4" },
                                ...feat.value.values.map((v, vi) =>
                                    h.div(
                                        { class: "d-flex gap-2" },
                                        h.FormField(
                                            {
                                                id: `feature-${vi}-input-option-value`,
                                                value: v.value,
                                                placeholder: "Label (e.g. Red)",
                                                label: {
                                                    value: "Label (e.g. Red)",
                                                },
                                                enterkeyhint: "next",
                                                listeners: {
                                                    input: (e) => {
                                                        let current =
                                                            tool.deepCopy(
                                                                feat.value,
                                                            );
                                                        current.values[
                                                            vi
                                                        ].value =
                                                            e.target.value;
                                                        feat.value = current;
                                                    },
                                                    keydown: (e) => {
                                                        if (e.key === "Enter") {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.values.push(
                                                                {
                                                                    value: "",
                                                                    price: "",
                                                                },
                                                            );
                                                            feat.value =
                                                                current;
                                                        }
                                                    },
                                                },
                                            },
                                            { $class: "flex-fill" },
                                        ),

                                        either(
                                            feat.value.has_different_prices,
                                            () =>
                                                h.input({
                                                    class: "form-control border",
                                                    style: "width: 60px;",
                                                    type: "number",
                                                    placeholder:
                                                        dc.userCurrency,
                                                    value: v.price,
                                                    listeners: {
                                                        input: (e) => {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.values[
                                                                vi
                                                            ].price =
                                                                e.target.value;
                                                            feat.value =
                                                                current;
                                                        },
                                                        keydown: (e) => {
                                                            if (
                                                                e.key ===
                                                                "Enter"
                                                            ) {
                                                                let current =
                                                                    tool.deepCopy(
                                                                        feat.value,
                                                                    );
                                                                current.values.push(
                                                                    {
                                                                        value: "",
                                                                        price: "",
                                                                    },
                                                                );
                                                                feat.value =
                                                                    current;
                                                            }
                                                        },
                                                    },
                                                }),
                                        ),
                                        h.button(
                                            {
                                                class: "btn text-danger p-0",
                                                listeners: {
                                                    click: () => {
                                                        let current =
                                                            tool.deepCopy(
                                                                feat.value,
                                                            );
                                                        current.values.splice(
                                                            vi,
                                                            1,
                                                        );
                                                        feat.value = current;
                                                    },
                                                },
                                            },
                                            h.i({ class: "bi bi-x-lg" }),
                                        ),
                                    ),
                                ),
                                h.button(
                                    {
                                        class: "btn btn-link text-decoration-none p-0 text-start small fw-bold",
                                        listeners: {
                                            click: () => {
                                                let current = tool.deepCopy(
                                                    feat.value,
                                                );
                                                current.values.push({
                                                    value: "",
                                                    price: "",
                                                });
                                                feat.value = current;
                                            },
                                        },
                                    },
                                    "+ Add Option",
                                ),
                            ),
                        ],
                        () =>
                            h.div(
                                { class: "mb-4" },
                                h.label(
                                    {
                                        class: "form-label fw-bold small text-muted",
                                    },
                                    "PLACEHOLDER",
                                ),
                                h.input({
                                    class: "form-control bg-light border p-3 rounded-3",
                                    placeholder: "e.g. Enter your name here",
                                    value: feat.value.values[0]?.value || "",
                                    listeners: {
                                        input: (e) => {
                                            if (!feat.value.values[0]) {
                                                feat.value.values[0] = {
                                                    value: "",
                                                    price: "",
                                                };
                                            }

                                            updateStateValue(feat, (value) => {
                                                value.values[0].value = e.target.value;
                                                return value;
                                            });
                                        },
                                    },
                                }),
                                h.small(
                                    { class: "text-muted d-block mt-1" },
                                    "This text guides the customer on what to type.",
                                ),

                                // Number Input pricing (e.g. sold by weight: "for every
                                // 0.5, the price is 10" -> entering 3 costs 60)
                                either(
                                    feat.value.choice_type === "number",
                                    () => this.renderNumberPricingFields(feat),
                                ),
                            ),
                    ),

                    // Action
                    h.div(
                        { class: "mt-5" },
                        h.button(
                            {
                                class: "btn btn-primary w-100 rounded-pill py-3 fw-bold",
                                listeners: { click: () => this.saveFeature() },
                            },
                            "Confirm Attribute",
                        ),
                    ),
                );
            }),
        );
    }

    // --- Number Input Pricing (interval + price-per-interval) ---
    // e.g. a product sold by weight: "for every 0.5[kg], the price is 10"
    // -> a customer entering 3 would pay (3 / 0.5) * 10 = 60.
    renderNumberPricingFields(feat) {
        return h.div(
            { class: "mt-4 pt-3 border-top" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-3",
                },
                h.h6({ class: "fw-bold mb-0" }, "Affects Price"),
                h.div(
                    { class: "form-check form-switch" },
                    h.input(
                        {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "number-price-toggle",
                            listeners: {
                                change: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.has_different_prices = e.target.checked;
                                    feat.value = current;
                                },
                            },
                        },
                        either(feat.value.has_different_prices, {
                            checked: true,
                        }),
                    ),
                    h.label(
                        {
                            class: "form-check-label small text-muted",
                            for: "number-price-toggle",
                        },
                        "Custom Price",
                    ),
                ),
            ),

            either(feat.value.has_different_prices, () => [
                h.div(
                    { class: "d-flex gap-2 mb-2" },
                    h.div(
                        { class: "flex-fill" },
                        h.label(
                            { class: "form-label small text-muted mb-1" },
                            "FOR EVERY",
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            type: "number",
                            min: "0",
                            step: "any",
                            placeholder: "e.g. 0.5",
                            value: feat.value.price_interval ?? "",
                            listeners: {
                                input: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.price_interval = e.target.value;
                                    feat.value = current;
                                },
                            },
                        }),
                    ),
                    h.div(
                        { class: "flex-fill" },
                        h.label(
                            { class: "form-label small text-muted mb-1" },
                            `PRICE (${dc.userCurrency})`,
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            type: "number",
                            min: "0",
                            step: "any",
                            placeholder: "e.g. 10",
                            value: feat.value.price_per_interval ?? "",
                            listeners: {
                                input: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.price_per_interval = e.target.value;
                                    feat.value = current;
                                },
                            },
                        }),
                    ),
                ),
                h.small(
                    { class: "text-muted d-block" },
                    "Example: for every 0.5, the price is 10 — a customer entering 3 would pay 60.",
                ),
            ]),
        );
    }

    renderToggleQuestionInForm(key, question, help) {
        return h.div(
            {
                class: "d-flex justify-content-between align-items-center gap-3",
            },
            h.div(
                { class: "flex-fill" },
                h.h6({ class: "fw-bold mb-0 small" }, question),
                h.p(
                    {
                        class: "text-muted small mb-0",
                        style: "font-size: 0.75rem;",
                    },
                    help,
                ),
            ),
            h.div(
                { class: "btn-group p-1 bg-light rounded-pill" },
                v(this.currentFeature, (feat) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                !feat[key]
                                    ? "bg-danger-subtle text-danger"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => {
                                    let c = tool.deepCopy(feat.value);
                                    c[key] = false;
                                    feat.value = c;
                                },
                            },
                        },
                        "No",
                    ),
                ),
                v(this.currentFeature, (feat) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                feat[key]
                                    ? "bg-success-subtle text-success"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => {
                                    let c = tool.deepCopy(feat.value);
                                    c[key] = true;
                                    feat.value = c;
                                },
                            },
                        },
                        "Yes",
                    ),
                ),
            ),
        );
    }

    saveFeature() {
        const feat = this.currentFeature.value;
        if (!feat.name)
            return inform("Please enter an attribute name", "warning");

        if (
            feat.choice_type === "number" &&
            feat.has_different_prices &&
            (!(parseFloat(feat.price_interval) > 0) ||
                !(parseFloat(feat.price_per_interval) > 0))
        ) {
            return inform(
                "Please enter a valid interval and price greater than 0",
                "warning",
            );
        }

        const index = this.editingFeatureIndex.value;
        let current = this.features.value;
        current ??= [];

        if (index === -1) {
            current.push(feat);
        } else {
            current[index] = feat;
        }

        this.features.value = current;

        this.featureHolder.hide();
    }

    // --- Helper UI Components ---

    renderInput(name, label, placeholder, type = "text", help = "") {
        return h.div(
            { class: "mb-4" },
            h.label({ class: "form-label fw-bold mb-1" }, label),
            h.input({
                class: "form-control bg-light border p-3 rounded-3",
                type: type,
                value: this.formData[name],
                listeners: {
                    input: (e) => (this.formData[name] = e.target.value),
                },
                placeholder: placeholder,
            }),
            help ? h.small({ class: "text-muted mt-1 d-block" }, help) : null,
        );
    }

    renderSelect(name, label, options, help = "") {
        return h.div(
            { class: "mb-4" },
            h.label({ class: "form-label fw-bold mb-1" }, label),
            h.select(
                {
                    class: "form-select bg-light border p-3 rounded-3",
                    listeners: {
                        change: (e) => (this.formData[name] = e.target.value),
                    },
                },
                h.option({ value: "" }, "Select..."),
                ...options.map((opt) =>
                    h.option(
                        {
                            value: opt.value,
                        },
                        either(this.formData[name] == opt.value, {
                            selected: true,
                        }),
                        opt.label,
                    ),
                ),
            ),
            help ? h.small({ class: "text-muted mt-1 d-block" }, help) : null,
        );
    }

    renderTextarea(name, label, placeholder, help = "") {
        return h.div(
            { class: "mb-4" },
            h.label({ class: "form-label fw-bold mb-1" }, label),
            h.textarea(
                {
                    class: "form-control bg-light border p-3 rounded-3",
                    rows: 3,
                    listeners: {
                        input: (e) => (this.formData[name] = e.target.value),
                    },
                    placeholder: placeholder,
                },
                this.formData[name],
            ),
            help ? h.small({ class: "text-muted mt-1 d-block" }, help) : null,
        );
    }

    renderToggleQuestion(stateKey, question, help) {
        return h.div(
            {
                class: "d-flex justify-content-between align-items-center gap-4 py-3 text-start",
            },
            h.div(
                { class: "flex-fill" },
                h.h6({ class: "fw-bold mb-1" }, question),
                h.p({ class: "text-muted small mb-0" }, help),
            ),
            h.div(
                { class: "btn-group p-1 bg-light rounded-pill" },
                v(this[stateKey], (val) =>
                    h.button(
                        {
                            class: `btn btn-sm rounded-pill py-2 px-3 fw-bold ${
                                !val.value
                                    ? "bg-danger-subtle text-danger"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => (this[stateKey].value = false),
                            },
                        },
                        "No",
                    ),
                ),
                v(this[stateKey], (val) =>
                    h.button(
                        {
                            class: `btn btn-sm rounded-pill py-2 px-3 fw-bold ${
                                val.value
                                    ? "bg-success-subtle text-success"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => {
                                    this[stateKey].value = true;
                                    if (stateKey === "availableAtAllBranches") {
                                        this.selectedBranches.value = [];
                                    }
                                },
                            },
                        },
                        "Yes",
                    ),
                ),
            ),
        );
    }

    renderSkipStep(message, ...args) {
        return h.div(
            { class: "text-center py-5 animate-step" },
            h.div(
                {
                    class: "bg-light rounded-circle circle mx-auto mb-4 p-4",
                    style: "width: 100px; height: 100px;",
                },
                h.i({ class: "bi bi-fast-forward-fill text-muted fs-1" }),
            ),
            h.h4({ class: "fw-bold mb-3" }, "Step Skipped"),
            h.p({ class: "text-muted mb-5" }, message),
            ...args,
            this.renderNavigationButtons(),
        );
    }

    renderNavigationButtons() {
        return h.div(
            { class: "d-flex justify-content-between align-items-center mt-5" },
            h.button(
                {
                    class: "btn btn-white border rounded-pill px-3 fw-bold d-flex align-items-center",
                    listeners: { click: () => this.prevStep() },
                },
                h.i({ class: "bi bi-arrow-left me-2" }),
                "Back",
            ),
            h.button(
                {
                    class: "btn btn-primary rounded-pill px-3 fw-bold shadow-sm align-items-center d-flex",
                    listeners: { click: () => this.nextStep() },
                },
                "Continue",
                h.i({ class: "bi bi-arrow-right ms-2" }),
            ),
        );
    }

    renderFeatureItem(feature, index) {
        return h.div(
            {
                class: "card border-0 shadow-none bg-light p-4",
                style: "border-radius: 16px;",
            },
            h.div(
                { class: "d-flex justify-content-between align-items-start" },
                h.div(
                    { class: "flex-fill" },
                    h.h6({ class: "fw-bold mb-1" }, feature.name),
                    h.div(
                        { class: "text-muted small" },
                        h.span(
                            { class: "badge bg-white text-dark border me-2" },
                            feature.choice_type.replace("_", " "),
                        ),
                        either(
                            feature.is_required,
                            () => h.span({ class: "text-danger" }, "Required"),
                            () => "Optional",
                        ),
                    ),
                    either(
                        feature.values.length > 0 &&
                            ["single_choice", "multiple_choice"].includes(
                                feature.choice_type,
                            ),
                        () =>
                            h.div(
                                { class: "mt-3 d-flex flex-wrap gap-2" },
                                ...feature.values.map((v) =>
                                    h.span(
                                        {
                                            class: "badge bg-white text-primary border rounded-pill",
                                        },
                                        v.value,
                                        either(
                                            feature.has_different_prices &&
                                                v.price,
                                            () =>
                                                h.span(
                                                    {
                                                        class: "ms-1 text-muted fw-normal",
                                                    },
                                                    ` @ ${dc.userCurrency} ${v.price}`,
                                                ),
                                        ),
                                    ),
                                ),
                            ),
                    ),
                    either(
                        ["text", "number"].includes(feature.choice_type),
                        () =>
                            h.div(
                                { class: "mt-2 small text-muted italic" },
                                "Placeholder: ",
                                feature.values[0]?.value || "none",
                            ),
                    ),
                    either(
                        feature.choice_type === "number" &&
                            feature.has_different_prices,
                        () =>
                            h.div(
                                { class: "mt-1 small text-muted" },
                                "Rate: ",
                                h.span(
                                    { class: "fw-bold text-primary" },
                                    `Every ${feature.price_interval} = ${dc.userCurrency} ${feature.price_per_interval}`,
                                ),
                            ),
                    ),
                ),
                h.div(
                    { class: "d-flex gap-2" },
                    h.button(
                        {
                            class: "btn btn-white btn-sm rounded-circle border shadow-sm",
                            listeners: {
                                click: () => this.openFeatureForm(index),
                            },
                        },
                        h.i({ class: "bi bi-pencil" }),
                    ),
                    h.button(
                        {
                            class: "btn btn-white btn-sm rounded-circle border shadow-sm text-danger",
                            listeners: {
                                click: () => {
                                    let current = this.features.value;
                                    current.splice(index, 1);
                                    this.features.value = current;
                                },
                            },
                        },
                        h.i({ class: "bi bi-trash" }),
                    ),
                ),
            ),
        );
    }

    renderExtraItem(extra, index) {
        return h.div(
            {
                class: "card border-0 shadow-none bg-light p-4 mb-3",
                style: "border-radius: 20px;",
            },
            h.div(
                { class: "d-flex align-items-start gap-3 mb-4" },
                h.img({
                    src:
                        extra.thumbnail_path ||
                        "/assets/images/product-placeholder.png",
                    class: "rounded-4 shadow-sm",
                    style: "width: 64px; height: 64px; object-fit: cover;",
                }),
                h.div(
                    { class: "flex-fill" },
                    h.div({ class: "fw-bold fs-5 text-dark" }, extra.name),
                    h.div(
                        { class: "text-muted small" },
                        `Original Price: ${dc.userCurrency} ${extra.price}`,
                    ),
                ),
                h.button(
                    {
                        class: "btn btn-white btn-sm rounded-circle border shadow-sm text-danger",
                        listeners: {
                            click: () => {
                                updateStateValue(this.extras, (v) => {
                                    v.splice(index, 1);
                                    return v;
                                });
                            },
                        },
                    },
                    h.i({ class: "bi bi-trash" }),
                ),
            ),

            h.div(
                { class: "row g-4" },
                // Price Field
                h.div(
                    { class: "col-md-6" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase mb-2",
                        },
                        "Selling Price",
                    ),
                    h.div(
                        { class: "input-group input-group-lg" },
                        h.span(
                            {
                                class: "input-group-text bg-white border-end-0 text-muted",
                            },
                            dc.userCurrency,
                        ),
                        h.input({
                            class: "form-control border-start-0 bg-white ps-0",
                            type: "number",
                            value: extra.price,
                            disabled: true,
                            listeners: {
                                input: (e) => {
                                    extra.price = e.target.value;
                                    updateStateValue(this.extras, (v) => {
                                        v[index] = extra;
                                        return v;
                                    });
                                },
                            },
                        }),
                    ),
                    h.small(
                        { class: "text-muted mt-2 d-block" },
                        "Set how much this extra costs when added to this product.",
                    ),
                ),

                // Quantity Field
                h.div(
                    { class: "col-md-6" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase mb-2",
                        },
                        "Quantity",
                    ),
                    h.div(
                        { class: "d-flex align-items-center gap-2" },
                        h.input({
                            class: "form-control form-control-lg text-center bg-white border fw-bold flex-fill",
                            style: "width: 80px;",
                            type: "number",
                            value: extra.quantity,
                            disabled: true,
                            listeners: {
                                input: (e) => {
                                    extra.quantity = Math.max(
                                        1,
                                        parseInt(e.target.value) || 1,
                                    );
                                    updateStateValue(this.extras, (v) => {
                                        v[index] = extra;
                                        return v;
                                    });
                                },
                            },
                        }),
                    ),
                    h.small(
                        { class: "text-muted mt-2 d-block" },
                        "How many units of this extra are included?",
                    ),
                ),
            ),
        );
    }

    // --- Logic ---

    nextStep() {
        if (this.currentStep.value < 5) {
            this.currentStep.value++;
            scrollToTop();
        }
    }

    prevStep() {
        if (this.currentStep.value > 1) {
            this.currentStep.value--;
            scrollToTop();
        }
    }

    handleProductSearch(e) {
        const query = e.target.value.trim();
        if (this.productSearchTimeout) clearTimeout(this.productSearchTimeout);

        if (query.length < 2) {
            this.productSuggestions.value = [];
            this.showProductSuggestions.value = false;
            return;
        }

        this.productSearchTimeout = setTimeout(() => {
            this.fetchProductSuggestions(query);
        }, 300);
    }

    async fetchProductSuggestions(query) {
        this.loadingProductSuggestions.value = true;
        this.showProductSuggestions.value = true;

        try {
            const res = await api.get(
                `companies/${window.currentCompany?.id}/products/search`,
                { q: query },
            );
            if (res) {
                this.productSuggestions.value = res.data.result.data || [];
            }
        } catch (e) {
            consoleErrorOnLocal(e);
        } finally {
            this.loadingProductSuggestions.value = false;
        }
    }

    async fetchBranches() {
        this.loadingBranches.value = true;
        try {
            const res = await api.get(
                `companies/${this.formData.company_id}/branches`,
            );
            if (res) {
                this.branches.value = res.data.branches;
            }
        } catch (e) {
            consoleErrorOnLocal(e);
        } finally {
            this.loadingBranches.value = false;
        }
    }

    toggleBranch(id) {
        updateStateValue(this.selectedBranches, (v) => {
            if (v.includes(id)) {
                return v.filter((bid) => bid !== id);
            }
            v.push(id);
            return v;
        });
    }

    addExtraProduct(prod, input = null) {
        const existing = this.extras.value.find(
            (e) => e.buyable_id === prod.id,
        );
        if (existing) {
            existing.quantity++;
            updateStateValue(this.extras, (v) => {
                return v;
            });
        } else {
            updateStateValue(this.extras, (v) => {
                v.push({
                    buyable_id: prod.id,
                    buyable_type: "App\\Models\\Product",
                    quantity: 1,
                    name: prod.name,
                    price: prod.selling_price,
                    thumbnail_path: prod.thumbnail_path,
                });
                return v;
            });
        }

        this.showProductSuggestions.value = false;
        this.productSuggestions.value = [];

        if (input) {
            input.value = "";
        }
    }

    addFeature() {
        this.openFeatureForm();
    }

    addExtra() {
        // This is now handled by search
    }

    triggerUpload(id) {
        document.getElementById(id).click();
    }

    setCropAspect(key) {
        const ratio = CROP_ASPECT_RATIOS.find((r) => r.key === key);
        if (!ratio || !this.cropper.obj) return;
        this.cropperAspectKey = key;
        this.cropper.obj.setAspectRatio(ratio.value);
        setActiveAspectButton(dom, key);
    }

    zoomCropper(delta) {
        this.cropper.obj?.zoom(delta);
    }

    rotateCropper(deg) {
        this.cropper.obj?.rotate(deg);
    }

    flipCropper(direction) {
        if (!this.cropper.obj) return;
        if (direction === "horizontal") {
            this.cropperFlip.x = -this.cropperFlip.x;
            this.cropper.obj.scaleX(this.cropperFlip.x);
        } else {
            this.cropperFlip.y = -this.cropperFlip.y;
            this.cropper.obj.scaleY(this.cropperFlip.y);
        }
    }

    resetCropper() {
        if (!this.cropper.obj) return;
        this.cropper.obj.reset();
        this.cropperFlip = { x: 1, y: 1 };
        this.cropperAspectKey = "16-9";
        this.cropper.obj.setAspectRatio(16 / 9);
        setActiveAspectButton(dom, "16-9");
    }

    handleImageUpload(e, type) {
        const files = e.target.files;
        if (!files.length) return;

        const handleFile = (file) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.addEventListener("load", () => {
                const src = fileReader.result;
                this.cropperAspectKey = "16-9";
                this.cropperFlip = { x: 1, y: 1 };

                const options = new tool.ModalOptions();
                options.buttons.right.text = "Crop & Confirm";
                options.buttons.left.text = "Cancel";
                options.classes.buttons.right =
                    "btn btn-primary rounded-pill px-4";
                options.classes.dialog = "modal-fullscreen";
                options.classes.body = "d-flex flex-column p-0";
                options.staticBackdrop();

                const { buttons, modal } = tool.modal(
                    type === "thumbnail"
                        ? "Crop Main Photo"
                        : "Crop Additional Photo",
                    h.div(
                        { class: "d-flex flex-column h-100" },
                        renderCropperToolbar(this, this.cropperAspectKey),
                        h.div(
                            {
                                id: "cropper-image-viewport",
                                class: "position-relative",
                                style: "max-height: 500px; overflow: hidden; background: #212529;",
                            },
                            h.EditProductImageForm(src, {
                                style: "max-height: 500px; overflow: hidden;",
                            }),
                        ),
                    ),
                    options,
                );

                forceFullscreenModalLayout(modal.element);

                modal.element.addEventListener("shown.bs.modal", () => {
                    const preview = dom.id("epif-image-view");
                    preview.classList.remove("d-none");

                    this.cropper.obj = new Cropper(preview, {
                        aspectRatio: 16 / 9,
                        viewMode: 2,
                        autoCropArea: 1,
                        background: true,
                        responsive: true,
                        minContainerHeight: 350,
                    });
                });

                buttons.left.button.addEventListener("click", () =>
                    modal.close(),
                );

                buttons.right.button.addEventListener("click", () => {
                    const cropData = this.cropper.obj.getData();
                    const croppedSrc = this.cropper.obj
                        .getCroppedCanvas()
                        .toDataURL();

                    if (type === "thumbnail") {
                        this.thumbnail.value = {
                            original: src,
                            cropped: croppedSrc,
                            cropData: cropData,
                        };
                    } else {
                        updateStateValue(this.previewImages, (v) => {
                            v.push({
                                original: src,
                                cropped: croppedSrc,
                                cropData: cropData,
                            });
                            return v;
                        });
                    }
                    modal.close();
                });
            });
        };

        if (type === "thumbnail") {
            handleFile(files[0]);
        } else {
            Array.from(files).forEach((file) => handleFile(file));
        }
    }

    async submit(btn) {
        // 1. Basic Info Validation (Step 1)
        const name = this.formData.name?.trim();
        const price = this.formData.selling_price;
        const processingTime = this.formData.processing_time;
        const shortDescription = this.formData.short_description?.trim();

        if (!name) {
            inform("Product name is required", STRINGS.ERROR);
            this.currentStep.value = 1;
            return;
        }
        if (!price || parseFloat(price) < 0) {
            inform(
                "Product price must be a valid positive number",
                STRINGS.ERROR,
            );
            this.currentStep.value = 1;
            return;
        }
        if (!processingTime) {
            inform("Processing time is required", STRINGS.ERROR);
            this.currentStep.value = 1;
            return;
        }
        if (!shortDescription) {
            inform("Short description is required", STRINGS.ERROR);
            this.currentStep.value = 1;
            return;
        }

        // 2. Branches/Availability Validation (Step 5)
        if (
            !this.availableAtAllBranches.value &&
            this.selectedBranches.value.length === 0
        ) {
            inform(
                "Please select at least one branch or enable availability for all branches",
                STRINGS.ERROR,
            );
            this.currentStep.value = 5;
            return;
        }

        dom.disable(btn);
        h.Spinner({ parent: btn, resetParent: true });

        const data = {
            ...this.formData,
            features: this.hasAttributes.value ? this.features.value : [],
            extras: this.hasExtras.value ? this.extras.value : [],
            branches: this.availableAtAllBranches.value
                ? []
                : this.selectedBranches.value,
            available_at_all_branches: this.availableAtAllBranches.value,
            should_enhance_images: this.shouldEnhanceImages.value,
            has_stock_information: this.hasStockInfo.value,
            organization: {
                id: window.currentCompany.id,
                type: "Company",
            },
        };

        try {
            if (this.thumbnail.value) {
                data.thumbnail = {
                    original: await dataURLtoBlob(
                        this.thumbnail.value.original,
                    ),
                    cropped: await dataURLtoBlob(this.thumbnail.value.cropped),
                    cropData: this.thumbnail.value.cropData,
                };
            }

            if (
                this.previewImages.value &&
                this.previewImages.value.length > 0
            ) {
                data.gallery = [];
                for (const img of this.previewImages.value) {
                    data.gallery.push({
                        original: await dataURLtoBlob(img.original),
                        cropped: await dataURLtoBlob(img.cropped),
                        cropData: img.cropData,
                    });
                }
            }

            const formData = new FormData();
            appendToFormData(formData, data);

            const res = await api.post("products", formData, {
                fetch_using: "browser",
                "remove-content-type": true,
            });

            if (res) {
                inform("Product added successfully!", STRINGS.SUCCESS);
                broker.send(
                    $e.product.stored,
                    payload({ productId: res.data.id }),
                );

                router.to("business.manage.inventory", {
                    companyId: window.currentCompany.id,
                });
            }
        } catch (e) {
            inform("Failed to save product.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Finish & Save", { parent: btn, resetParent: true });
            h.i({ class: "bi bi-check-lg ms-2", parent: btn });
        }
    }
}

ojs(AddProduct);
